import { useState, useEffect } from "react";
import { API_BASE_URL } from "../utils/constants";

export default function AdminProductCard({ product, onEdit }) {
  const [focusedImage, setFocusedImage] = useState(() => {
    if (product.images.length > 0)
      return `${API_BASE_URL}/uploads/${product.images?.[0]?.filename}`;
    else if (product.apiImage != "") return product.apiImage;
    else return "";
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = async () => {
    setIsEditing(true);
    await onEdit(product, () => setIsEditing(false));
  };

  useEffect(() => {
    const list = (product.images || []).map(
      (i) => `${API_BASE_URL}/uploads/${i.filename}`
    );
    if (!focusedImage || !list.includes(focusedImage)) {
      if (list.length > 0) setFocusedImage(list[0]);
      else if (product.apiImage) setFocusedImage(product.apiImage);
      else setFocusedImage("");
    }
  }, [product.images]);
  return (
    <div className="border p-4 rounded flex flex-col gap-2">
      <div className="flex flex-col gap-6">
        {/* Main Image */}
        {focusedImage && (
          <img
            src={`${focusedImage}`}
            alt={`${product.name}`}
            className="w-40 h-40 object-cover border rounded"
          />
        )}

        {/* Product Info */}
        <div className="flex-1">
          <h2 className="text-xl font-bold">
            {product.subname || product.name}
          </h2>
          <p className="text-sm text-gray-500 mb-1">Tags: {product.tag}</p>
          <p className="text-sm mb-1">
            Price: {parseFloat(product.price).toFixed(2)} rsd
          </p>
          <p className="text-sm mb-1">
            Stock: {product.stock}
          </p>
          <p className="text-sm mb-1">
            Status: {product.is_active ? '✅': '❌'} 
          </p>
          <p className="text-sm">Description: {product.description}</p>
        </div>
      </div>

      {/* Thumbnails */}
      {product.images?.length > 1 && (
        <div className="mt-2 flex overflow-x-auto gap-2">
          {product.images.map((img, idx) => (
            <img
              key={idx}
              src={`${API_BASE_URL}/uploads/${img.filename}`}
              alt={`thumb-${idx}`}
              onClick={() =>
                setFocusedImage(`${API_BASE_URL}/uploads/${img.filename}`)
              }
              className={`w-20 h-20 object-cover border rounded cursor-pointer ${
                focusedImage === img.filename ? "ring-2 ring-black" : ""
              }`}
            />
          ))}
        </div>
      )}
      {!isEditing && (
        <div className="flex flex-col gap-1 text-sm">
          <button
            onClick={handleEditClick}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
}
